import { use } from "react";
import type { ConfigContextProps } from "@/contexts/ConfigContext";
import ConfigContext from "@/contexts/ConfigContext";

export const useConfigContext = (): ConfigContextProps => {
  const configCtx = use(ConfigContext);

  if (configCtx === null) {
    throw new Error("Config context is null");
  }

  return configCtx;
};
